import React from "react";
import {
  AiOutlineInstagram,
  AiFillLinkedin,
  AiFillGithub,
} from "react-icons/ai";

const Footer = () => {
  return (
    <div>
      <div className="footer">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
          <path
            fill="#001220"
            fill-opacity="1"
            d="M0,192L48,176C96,160,192,128,288,96C384,64,480,32,576,42.7C672,53,768,107,864,106.7C960,107,1056,53,1152,37.3C1248,21,1344,43,1392,53.3L1440,64L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          ></path>
        </svg>
        <div className="row justify-content-center footer-content">
          <div className="col-md-6">
            <div>
              <p>Designed By</p>
              <hr />
              <div className="d-flex justify-content-between px-2">
                <a href="https://www.instagram.com/py_zubair/">
                  <AiOutlineInstagram className="social-media-icon" />
                </a>
                <a href="https://www.linkedin.com/in/alzubair-alqaraghuli-272918233/">
                  <AiFillLinkedin className="social-media-icon" />
                </a>
                <a href="https://github.com/Alzubair98">
                  <AiFillGithub className="social-media-icon" />
                </a>
              </div>
              <hr />
              <br />
              <p>Alzubair Alqaraghuli</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
